<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>SFTP Path</span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtSftpPath"
        v-model="sftpPath"
        variant="solo"
        density="compact"
        placeholder="SFTP Path"
        :disabled="!clientProviderSftpPathUpdateActionEnabled"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ClientProviderSftp',

  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },

  emits: ['update:model-value'],

  data() {
    return {
      sftpPath: ''
    };
  },

  computed: {
    ...mapState({
      clientProviderSftpPathUpdateActionEnabled: (state) =>
        state.common.clientProviderSftpPathUpdateActionEnabled
    })
  },

  watch: {
    modelValue(newValue) {
      this.resetData(newValue);
    },
    sftpPath(newValue) {
      this.$emit('update:model-value', { sftpPath: newValue });
    }
  },

  async mounted() {
    this.resetData(this.modelValue);
  },

  methods: {
    async resetData(newValue) {
      const { sftpPath } = newValue || { sftpPath: '' };
      this.sftpPath = sftpPath || '';
    }
  }
};
</script>
<style scoped></style>
